// DS: i7.23
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorRedo = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.912 5.707a.992.992 0 010-1.414 1.02 1.02 0 011.43 0l2.862 2.828a.992.992 0 010 1.415l-2.861 2.828a1.02 1.02 0 01-1.431 0 .992.992 0 010-1.414l.96-.95h-4.797c-2.514 0-4.552 2.015-4.552 4.5S8.561 18 11.075 18h2.674c.558 0 1.011.448 1.011 1s-.453 1-1.011 1h-2.674C7.444 20 4.5 17.09 4.5 13.5S7.444 7 11.075 7h5.145l-1.308-1.293z"
    })));
};
EditorRedo.displayName = 'EditorRedo';
export default EditorRedo;

//# sourceMappingURL=EditorRedo.js.map